import React from "react";
import TimeAgo from "react-timeago";
import { cleanDate } from "../../../../util/app";

function BMIListing({ items = [] }) {
    if (!items.length)
        return (
            <div className="text-center">
                <h4 className="text-pink">No BMI result is recorded yet!</h4>
            </div>
        );
    return (
        <div className="row">
            <div className="col-4 bg-primary pl-5">
                <h5>Historical Physical Observation Data</h5>
            </div>
            <div className="col-12">
                <table className="table table-bordered">
                    <thead>
                        <td style={{ backgroundColor: "aliceblue" }} className="text-center">
                            <strong>SN</strong>
                        </td>
                        <td style={{ backgroundColor: "aliceblue" }}>
                            <strong>Date</strong>
                        </td>
                        <td style={{ backgroundColor: "aliceblue" }} className="text-center">
                            <strong> Weight</strong>
                        </td>
                        <td style={{ backgroundColor: "aliceblue" }} className="text-center">
                            <strong> Height</strong>
                        </td>
                        <td style={{ backgroundColor: "aliceblue" }}>
                            <strong> BMI</strong>
                        </td>
                        <td style={{ backgroundColor: "aliceblue" }} className="text-centner">
                            <strong>Weight Loss%</strong>
                        </td>
                    </thead>
                    <tbody>
                        {items.map((item, index) => (
                            <tr key={index}>
                                <td className="text-center">
                                    <strong>{index + 1}</strong>
                                </td>

                                <td className="view-message">
                                    <strong>{cleanDate(item.created_at, true)}</strong>
                                    <p className="text-muted">
                                        <TimeAgo date={item.created_at} />
                                    </p>
                                </td>

                                <td className="text-center">
                                    <span>{item.weight}</span>
                                </td>
                                <td className="text-center">
                                    <span>{item.height}</span>
                                </td>
                                <td className="view-message">
                                    <strong className="text-success">{item.bmi}</strong>
                                    <br />
                                    {item.bmi < 18.6 && <span className="badge badge-warning">Under weight</span>}
                                    {item.bmi > 18.6 && item.bmi < 24.9 && <span className="badge badge-success">Normal weight</span>}
                                    {item.bmi > 24.9 && <span className="badge badge-danger">Overweight</span>}
                                </td>
                                <td className="view-message text-center">{item.lossWeight}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default BMIListing;
